import { faCheck, faX } from '@fortawesome/pro-solid-svg-icons'
import { ActionButton, HeadingItem, QuantityAdjuster } from 'components'
import { TripContext } from 'contexts'
import { Popup } from 'devextreme-react/popup'
import _ from 'lodash'
import React, { FC, useContext, useEffect, useState } from 'react'
import { OrderItem } from 'services/types'
import './verify-value-pop-up.scss';
import { envConfig } from 'config';

type Props = {
    isVisible: boolean,
    itemId: number,
    countedQuantity: number,
    onConfirm: (quantity: number) => void
}

export const VerifyValuePopUp: FC<Props> = ({ isVisible, itemId, countedQuantity, onConfirm }) => {
    const tripContext = useContext(TripContext)
    const iconSize = '3x'
    const buttonSize = '64px'
    const config = envConfig();

    useEffect(() => {
        if (isVisible) {
            setInputCountedQuantity(countedQuantity)
        }
    }, [isVisible, countedQuantity])

    const [inputCountedQuantity, setInputCountedQuantity] = useState<number>(countedQuantity)
    const [showExtraConfirmation, setShowExtraConfirmation] = useState(false)

    const [reenteredQuantity, setReenteredQuantity] = useState<number>(0)

    let item: OrderItem = tripContext.orderItems.find(oi => oi.id == itemId) ?? {} as OrderItem

    const handleQuantityChanged = async (newValue: number): Promise<void> => {
        setInputCountedQuantity(newValue)
    }

    const handleConfirmButton = (): void => {
        if (inputCountedQuantity >= item.shippedQuantity + config.QUANTITY_LIMIT_FOR_DISCREPANCY) {
            setShowExtraConfirmation(true)
        } else {
            onConfirm(inputCountedQuantity)
        }
    }

    return (
        <Popup
            visible={isVisible}
            dragEnabled={false}
            closeOnOutsideClick={false}
            showTitle={false}
            width={325}
            height={450}
        >
            <HeadingItem text={`Verify Counted Qty`} />
            <>
                <hr />

                <QuantityAdjuster
                    id={''}
                    quantity={inputCountedQuantity}
                    minValue={0}
                    iconSize={iconSize}
                    buttonSize={buttonSize}
                    inputDelay={500}
                    showPlusAndMinusButtons={false}
                    onQuantityAdjusted={(id: number | string, quantity: number) => handleQuantityChanged(quantity)}
                />

                <div className='verify-value-pop-up-buttons'>
                    <ActionButton
                        buttonText="Cancel"
                        icon={faX}
                        buttonColor={'#EB5757'}
                        buttonWidth={"100px"}
                        onClick={() => {
                            item.countedQuantity = item.shippedQuantity
                            tripContext.orderItems.put(item)
                        }}
                    />
                    <ActionButton
                        buttonText="Confirm"
                        enabled={true}
                        icon={faCheck}
                        buttonColor={'#76AB21'}
                        circular={false}
                        onClick={handleConfirmButton}
                    />
                </div>
            </>

            <Popup
                visible={showExtraConfirmation}
                dragEnabled={false}
                closeOnOutsideClick={false}
                showTitle={false}
                width={300}
                height={300}
            >
                <HeadingItem text="Verify The Counted Quantity" />
                <>
                    <div className='verify-value-pop-up-text-wrapper'>
                        <div className='verify-value-pop-up-text'>Did you mean <span className='bold'>{inputCountedQuantity}</span>?</div>
                        <div className='verify-value-pop-up-text confirm'>Confirm by entering number</div>
                    </div>

                    <QuantityAdjuster
                        id="reentry"
                        quantity={reenteredQuantity}
                        minValue={0}
                        iconSize={iconSize}
                        buttonSize={buttonSize}
                        inputDelay={300}
                        showPlusAndMinusButtons={true}
                        onQuantityAdjusted={(id, quantity) => setReenteredQuantity(quantity)}
                    />

                    <div className='verify-value-pop-up-buttons' style={{ marginTop: '16px' }}>
                        <ActionButton
                            buttonText="Cancel"
                            icon={faX}
                            buttonColor={'#EB5757'}
                            buttonWidth={"100px"}
                            onClick={() => setShowExtraConfirmation(false)}
                        />
                        <ActionButton
                            buttonText="Confirm"
                            icon={faCheck}
                            buttonColor={'#76AB21'}
                            buttonWidth={"100px"}
                            enabled={reenteredQuantity === inputCountedQuantity}
                            dataTestId='verify-confirm'
                            onClick={() => {
                                setShowExtraConfirmation(false)
                                onConfirm(inputCountedQuantity)
                            }}
                        />
                    </div>
                </>
            </Popup>


        </Popup>
    )
}